import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { clientAxios8080 } from '../../../../configs/axios';

export const getNotifications = createAsyncThunk('notificationPanel/getData', async (param) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .get(`/ms-repositorio/file/getNotificaciones?idUsuario=${param.idUser}&role=${param.roleId}`)
      .then((response) => {
        resolve(createNotification(response.data.data, param.roleId));
      })
      .catch((error) => reject(error));
  });
});

export const dismissItem = createAsyncThunk('notificationPanel/dismissItem', async (param, { dispatch }) => {
  return new Promise((resolve, reject) => {
    clientAxios8080
      .put(`/ms-repositorio/file/updateNotificacion?idFile=${param.idFile}`)
      .then((response) => {
        dispatch(
          getNotifications({
            idUser: param.idUser,
            roleId: param.roleId,
          })
        );
        resolve(response.data.data);
      })
      .catch((error) => reject(error));
  });
});

const createNotification = (data, role) => {
  const arr = [];

  data.forEach((item, index) => {
    let obj = {};
    if (role === 'Administrador') {
      obj = {
        id: item.idArchivo,
        icon: 'heroicons-solid:folder',
        title: 'Archivo por aprobar',
        rejectMsg: '',
        description: `Nombre: ${item.fileName} 
        Ruta:  ${item.path}`,
      };
    } else {
      obj = {
        id: item.idArchivo,
        icon: 'heroicons-solid:folder',
        title: 'Archivo rechazado',
        rejectMsg: item.motivoRechazo,
        description: `Nombre: ${item.fileName} 
        Ruta:  ${item.path}`,
      };
    }

    arr.push(obj);
  });
  return arr;
};

const notificationsAdapter = createEntityAdapter({});

const initialState = notificationsAdapter.upsertMany(notificationsAdapter.getInitialState(), []);

export const { selectAll: selectNotifications, selectById: selectNotificationsById } = notificationsAdapter.getSelectors(
  (state) => state.notificationPanel.data
);

const dataSlice = createSlice({
  name: 'notificationPanel/data',
  initialState,
  reducers: {},
  extraReducers: {
    [dismissItem.fulfilled]: (state, action) => notificationsAdapter.removeOne(state, action.payload),
    [getNotifications.fulfilled]: (state, action) => notificationsAdapter.setAll(state, action.payload),
  },
});

export default dataSlice.reducer;
